import React, { useState } from "react";
import _ from "lodash";
import { Row } from "../../components/Layout";
import { QuoteFormElements } from "./quoteValidation";
import { log } from "../../Helper";

function ForwarderQuoteForm({
  onUpdateFormData,
  selectedMachinesForQuote,
  dataUpdated,
}) {
  const [formData, setFormData] = useState({
    pickupdays: selectedMachinesForQuote.pickupDays,
    transitdays: selectedMachinesForQuote.transitDays,
    amount: selectedMachinesForQuote.amount,
    freetext: selectedMachinesForQuote.freeText,
    currency: selectedMachinesForQuote.currency,
  });
  const [dataUpdatedFlag, setDataUpdatedFlag] = useState(false);
  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData((preFormData) => ({
      ...preFormData,
      [name]: value,
    }));
    setDataUpdatedFlag(true);
  };
  dataUpdated(dataUpdatedFlag);
  onUpdateFormData(formData);
  return (
    <div id="quote-form-main-div" className="py-3">
      <form id="quote-form-tag" className="text-md">
        <Row>
          <QuoteFormElements
            selectedMachinesForQuote={selectedMachinesForQuote}
            onChange={handleFormChange}
            formData={formData}
            dataUpdatedFlag={dataUpdatedFlag}
          />
          <br />
        </Row>
      </form>
      <br />
    </div>
  );
}
export default ForwarderQuoteForm;
